var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "admin-sidebar",
      staticClass: "sidebar sidebar-open",
      attrs: { id: "admin-sidebar" }
    },
    [
      _c("nav", { staticClass: "sidebar-nav" }, [
        _c("ul", { staticClass: "nav" }, [
          _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c(
                "router-link",
                {
                  staticClass: "nav-link",
                  attrs: { to: { name: "admin/dashboard" } }
                },
                [
                  _c("i", { staticClass: "mr-2 fas fa-tachometer-alt" }),
                  _c("span", [_vm._v("Dashboard")])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.checkPermission("CreateUser")
            ? _c(
                "li",
                {
                  class: {
                    "nav-item nav-dropdown": true,
                    open: _vm.is_showing("nav-user-list")
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: {
                        "nav-dropdown-toggle": true,
                        "nav-link": true,
                        "nav-item-collapse": true,
                        active: _vm.is_showing("nav-user-list")
                      },
                      attrs: {
                        href: "javascript:void(0);",
                        id: "nav-users",
                        "data-target": "#nav-user-list"
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.toggle_collapse($event)
                        },
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggle_collapse($event)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "mr-2 fas fa-headset" }),
                      _c("span", [_vm._v("Users")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      class: {
                        collapse: true,
                        show: _vm.is_showing("nav-user-list")
                      },
                      attrs: {
                        id: "nav-user-list",
                        "data-target": "#nav-users"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active: _vm.isActive("manage-users")
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              class: {
                                "router-link-exact-active router-link-active": _vm.setTabActive(
                                  "users"
                                )
                              },
                              attrs: { to: { name: "manage-users" } }
                            },
                            [_c("span", [_vm._v("Manage Users")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active: _vm.isActive("adduser")
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: { name: "adduser" } }
                            },
                            [_c("span", [_vm._v("Add New User")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active: _vm.isActive("users/import-users")
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: { name: "users/import-users" } }
                            },
                            [_c("span", [_vm._v("Import Users")])]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("CreateAgency")
            ? _c(
                "li",
                {
                  class: {
                    "nav-item nav-dropdown": true,
                    open: _vm.is_showing("nav-agencies-list")
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: {
                        "nav-dropdown-toggle": true,
                        "nav-link": true,
                        "nav-item-collapse": true,
                        active: _vm.is_showing("nav-agencies-list")
                      },
                      attrs: {
                        id: "nav-agencies",
                        href: "javascript:void(0);",
                        "data-target": "#nav-agencies-list"
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.toggle_collapse($event)
                        },
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggle_collapse($event)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "mr-2 fas fa-globe" }),
                      _c("span", [_vm._v("Agencies")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      class: {
                        collapse: true,
                        show: _vm.is_showing("nav-agencies-list")
                      },
                      attrs: {
                        id: "nav-agencies-list",
                        "data-target": "#nav-agencies"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active: _vm.isActive("agencymanager")
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              class: {
                                "router-link-exact-active router-link-active": _vm.setTabActive(
                                  "agencies"
                                )
                              },
                              attrs: { to: { name: "agencymanager" } }
                            },
                            [_c("span", [_vm._v("Agency Manager")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active: _vm.isActive("addagency")
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              attrs: { to: { name: "addagency" } }
                            },
                            [_c("span", [_vm._v("+Add Agency")])]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm.checkPermission("GetAgencyAppointedCarriers")
            ? _c(
                "li",
                {
                  class: {
                    "nav-item nav-dropdown": true,
                    open: _vm.is_showing("nav-agencies-list")
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: {
                        "nav-dropdown-toggle": true,
                        "nav-link": true,
                        "nav-item-collapse": true,
                        active: _vm.is_showing("nav-agencies-list")
                      },
                      attrs: {
                        href: "javascript:void(0);",
                        id: "nav-carriers-appointed",
                        "data-target": "#nav-agencies-list"
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.toggle_collapse($event)
                        },
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggle_collapse($event)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "mr-2 fas fa-globe" }),
                      _c("span", [_vm._v("Agency")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      class: {
                        collapse: true,
                        show: _vm.is_showing("nav-agencies-list")
                      },
                      attrs: {
                        id: "nav-agencies-list",
                        "data-target": "#nav-carriers-appointed"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active:
                              _vm.isActive("agencymanager") &&
                              !_vm.$store.getters.getACStatus
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              class: {
                                "nav-item": true,
                                active:
                                  _vm.isActive("agencymanager") &&
                                  !_vm.$store.getters.getACStatus,
                                "inactive-link": _vm.$store.getters.getACStatus
                              },
                              attrs: {
                                to: {
                                  name: "agency-details",
                                  query: {
                                    agencyID: _vm.getAgencyID(),
                                    showTab: "am"
                                  }
                                }
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.checkTabStatusNav(false)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Agency Details")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active:
                              _vm.isActive("addagency") ||
                              _vm.$store.getters.getACStatus
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              class: {
                                "router-link-exact-active router-link-active": _vm.setTabActive(
                                  "ap"
                                )
                              },
                              attrs: {
                                to: {
                                  name: "editagency",
                                  query: {
                                    agencyID: _vm.getAgencyID(),
                                    showTab: "ap"
                                  }
                                }
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.checkTabStatusNav(true)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Appointed Carriers")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active:
                              _vm.isActive("carrierlogin") ||
                              _vm.$store.getters.getACStatus
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              class: {
                                "router-link-exact-active router-link-active": _vm.setTabActive(
                                  "cl"
                                )
                              },
                              attrs: {
                                to: {
                                  name: "editagency",
                                  query: {
                                    agencyID: _vm.getAgencyID(),
                                    showTab: "cl"
                                  }
                                }
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.checkTabStatusNav(false)
                                }
                              }
                            },
                            [_c("span", [_vm._v("Carrier Logins")])]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkPermission("GetAllCarriers")
            ? _c(
                "li",
                {
                  class: {
                    "nav-item nav-dropdown": true,
                    open: _vm.is_showing("nav-carriers-list")
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: {
                        "nav-dropdown-toggle": true,
                        "nav-link": true,
                        "nav-item-collapse": true,
                        active: _vm.is_showing("nav-carriers-list")
                      },
                      attrs: {
                        href: "javascript:void(0);",
                        id: "nav-carriers-manager",
                        "data-target": "#nav-carriers-list"
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.toggle_collapse($event)
                        },
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggle_collapse($event)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "mr-2 fas fa-umbrella" }),
                      _c("span", [_vm._v("Carriers")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      class: {
                        collapse: true,
                        show: _vm.is_showing("nav-carriers-list")
                      },
                      attrs: {
                        id: "nav-carriers-list",
                        "data-target": "#nav-carriers-manager"
                      }
                    },
                    [
                      _c(
                        "li",
                        {
                          class: {
                            "nav-item": true,
                            active: _vm.isActive("carriers/carrier-manager")
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "nav-link",
                              class: {
                                "router-link-exact-active router-link-active": _vm.setTabActive(
                                  "carriers"
                                )
                              },
                              attrs: { to: { name: "carrier-manager" } }
                            },
                            [_c("span", [_vm._v("Carrier Manager")])]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            {
              class: {
                "nav-item nav-dropdown": true,
                open: _vm.is_showing("nav-reports-list")
              }
            },
            [
              _c(
                "a",
                {
                  class: {
                    "nav-dropdown-toggle": true,
                    "nav-link": true,
                    "nav-item-collapse": true,
                    active: _vm.is_showing("nav-reports-list")
                  },
                  attrs: {
                    href: "javascript:void(0);",
                    id: "nav-reports",
                    "data-target": "#nav-reports-list"
                  },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.toggle_collapse($event)
                    },
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggle_collapse($event)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "mr-2 fas fa-chart-pie" }),
                  _c("span", [_vm._v("Reports")])
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  class: {
                    collapse: true,
                    show: _vm.is_showing("nav-reports-list")
                  },
                  attrs: {
                    id: "nav-reports-list",
                    "data-target": "#nav-reports"
                  }
                },
                [
                  _c(
                    "li",
                    {
                      class: {
                        "nav-item": true,
                        active: _vm.isActive("reports/carriers")
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: { to: { name: "reports/carriers" } }
                        },
                        [_c("span", [_vm._v("Carriers")])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class: {
                        "nav-item": true,
                        active: _vm.isActive("reports/states")
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: { to: { name: "reports/states" } }
                        },
                        [_c("span", [_vm._v("States")])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class: {
                        "nav-item": true,
                        active: _vm.isActive("reports/agents")
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: { to: { name: "reports/agents" } }
                        },
                        [_c("span", [_vm._v("Agents")])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      class: {
                        "nav-item": true,
                        active: _vm.isActive("reports/products")
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link",
                          attrs: { to: { name: "reports/products" } }
                        },
                        [_c("span", [_vm._v("Products")])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "disabled",
                      class: { "nav-item": true, active: _vm.isActive("#") }
                    },
                    [
                      _c(
                        "router-link",
                        { staticClass: "nav-link", attrs: { to: "#" } },
                        [_c("span", [_vm._v("Teams")])]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.hasPermissionsToDisplay(_vm.dailyActivityReportPermissions)
            ? _c("li", { staticClass: "nav-item" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c(
                "router-link",
                {
                  staticClass: "nav-link",
                  attrs: {
                    to: {
                      name: "your-profile",
                      query: { userID: _vm.getUserID() }
                    }
                  }
                },
                [
                  _c("i", { staticClass: "mr-2  fas fa-user-circle" }),
                  _c("span", [_vm._v("Your Profile")])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav-item disabled" },
            [
              _c(
                "router-link",
                { staticClass: "nav-link", attrs: { to: "#" } },
                [_c("span", [_vm._v("Tools")])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "nav-item" },
            [
              _c(
                "router-link",
                {
                  staticClass: "nav-link",
                  attrs: { to: { name: "training/videos" } }
                },
                [
                  _c("i", {
                    staticClass:
                      "mr-2 fas fa-sharp fa-regular fa-graduation-cap"
                  }),
                  _c("span", [_vm._v("Training Videos")])
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "sidebar-minimizer brand-minimizer",
        attrs: { "aria-label": "minimize-sidebar", type: "button" },
        on: {
          click: function($event) {
            return _vm.toggleNav("admin-sidebar")
          }
        }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "nav-link daily-activity-report",
        attrs: { href: "javascript:void(0);" }
      },
      [
        _c("i", { staticClass: "mr-2 fas fa-file-download" }),
        _c("span", [_vm._v("Daily Activity Report")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6907310e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6907310e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/Navigation.vue
// module id = null
// module chunks = 